
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

import vselect3 from "vselect3";

import api from "@/services/api.service";
import { IQuerySync, ISyncSystem } from "@/store/sync/types";

const Sync = namespace("sync");

@Component({
	components: {
		"v-select": vselect3
	}
})

export default class SyncSystemSelect extends Vue {
    @Prop({ type: Number, default: -1})
    public syncSystemId!: number;

    @Sync.Action getSyncSystems: () => Promise<void>;
    @Sync.Getter getSyncSystemDefaultOrFiltered: ISyncSystem[];

    public selectedSyncSystem: ISyncSystem = null;
    public syncSystems: ISyncSystem[] = [];
    public loadingSystem: boolean = false;

    // This select will always load 50 systems for search requests.
    private PAGE_NO: number = 1;
    private PAGE_SIZE: number = 50;
    private filter: string = "";

    public async mounted(): Promise<void> {
        await this.getSyncSystems();
    }

    @Watch("syncSystemId")
    public async onSyncSystemIdChanged(newValue: number) {
        // On adding sync entry or removing selected sync system, show default options.
        if (!newValue) {
            this.selectedSyncSystem = null;
            this.syncSystems = [ ...this.getSyncSystemDefaultOrFiltered ];
            return;
        }

        // Reset selected system, retrieve new one.
        this.selectedSyncSystem = null;
        this.loadingSystem = true;

        const { data } = await api.getSyncSystem(this.syncSystemId);
        const syncSystem = data;

        this.syncSystems = [];

        if(syncSystem) {
            // On success, set as selected and push to options.
            this.syncSystems.push(syncSystem);
            this.selectedSyncSystem = syncSystem;
        }
        this.loadingSystem = false;  
    }

    public async fetchSyncSystems(search: string, loading: (isLoading: boolean) => void) {
        if(!search) {
            search = "";
        }

        // Set filter value to determine which options to display, e.g. default or filtered.
        this.filter = search;

		if (search === "") {
            // When search string is empty, reset to selected sync system if exists. 
            this.syncSystems = [ ...this.getSyncSystemDefaultOrFiltered ];

            // Push the selected into the list if it does not exists to avoid duplicates.
            if (this.selectedSyncSystem && !this.syncSystems.some(x => x.syncSystemId === this.selectedSyncSystem.syncSystemId)) {
                this.syncSystems.push(this.selectedSyncSystem)
            }
		} else {
            // Retrieve subset of systems with a title that contains search string.
			loading(true)
            const { data } = await api.querySyncSystemsByTitle(this.PAGE_NO, this.PAGE_SIZE, search);
            this.syncSystems = data;
			loading(false)
		}
	}

    public syncSystemSelected(syncSystem: ISyncSystem)
    {
        this.$emit("SyncSystemSelected", syncSystem);
    }
}
